const MatrixPreset = Object.freeze({
  PRIORITISATION: 'PRIORITISATION',
  ALIGNMENT: 'ALIGNMENT',
});

export default MatrixPreset;
